export const NexusRoutes = {
  RentalListings: '/leasing/rentals/',
  RentalDetails: '/leasing/rentals/:rentalId/',
  ScheduleShowing: '/leasing/showings/',
  LeadsCreate: '/leasing/leads/',
  LeadDetails: '/leasing/leads/:uuid/',
  RentalAvailableTimes: '/leasing/rentals/:rentalId/available_times/',
  RentalSimilar: '/leasing/rentals/:rentalId/similar/',
  ShowingCancelByIdAndEmail: '/leasing/showings/:showingId/cancel/',
  ShowingCancel: '/leasing/showings/:showingUuid/cancel/',
  RentalAgentProfile: '/leasing/rental_agents/profile/',
};
